var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4777_247986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0C21.5303 0 0 21.5303 0 48C0 60.0318 4.43279 71.5566 12.6649 80.4222C21.9104 90.4274 34.4485 96 48 96C61.5515 96 74.0896 90.4274 83.3351 80.4222C91.4407 71.5569 96 60.0318 96 48C96 21.5303 74.4697 0 48 0Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7633 75.3561C78.7766 74.3429 79.6631 73.203 80.5496 71.9367C72.3175 62.9445 62.1855 57.6252 51.4204 56.6122C60.6658 54.9657 67.7582 46.8601 67.7582 36.9815C67.7582 25.963 58.8928 17.0977 48.0009 17.0977C37.109 17.0977 28.2436 25.963 28.2436 36.9815C28.2436 46.7335 35.3359 54.9657 44.5814 56.6122C33.6895 57.4987 23.6843 62.818 15.4521 71.9367C16.3387 73.0765 17.2252 74.2163 18.2385 75.3561C26.0907 83.7151 36.6026 88.401 48.0009 88.401C59.3992 88.401 69.911 83.7151 77.7633 75.3561Z",
    fill: "#907C4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4777_247986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e248a624bf50b8109ad01f0beb475fc1.svg";
export { ForwardRef as ReactComponent };